import React from "react";
import HrPage from "../component/HrPage";

const HrDashboard = () => (
  <div>
    <HrPage />
  </div>
);

export default HrDashboard;
